import IngredientDetail from "./ingredientDetail-v2";

export default IngredientDetail;
